<template>
  <div class="modal fade" id="specialistVehicleOneCModal" tabindex="-1" aria-labelledby="specialistVehicleOneCModalLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="specialistVehicleOneCModalLabel">Транспорт / Спец. техника</h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="error" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-5">
            <div class="d-flex flex-column text-light pe-0 pe-sm-10">
              <span v-html="error"></span>
            </div>
          </div>
          <form @submit.prevent="addVehicle">
            <div class="text-gray-700 fw-bold mb-3 ms-2">
              {{search ? 'Поиск ТС...' : 'Транспорт / Спец. техника'}}
            </div>
            <div class="row">
              <div class="col-6">
                <input-field
                    v-model="vehicle.registration.number"
                    @input="vehicle.registration.number=$event.target.value.toUpperCase()"
                    @keydown.enter="getVehicle(this.vehicle.registration.number, this.vehicle.vin, true)"
                    :required="true"
                    id="vehicle.registration.number"
                    name="vehicle.registration.number"
                    placeholder="Гос. номер ТС"
                    type="text"
                    mb="5"
                />
              </div>
              <div class="col-6">
                <input-field
                    v-model="vehicle.vin"
                    @keydown.enter="getVehicle(this.vehicle.registration.number, this.vehicle.vin, true)"
                    id="vehicle.vin"
                    name="vehicle_vin"
                    :required="true"
                    placeholder="VIN номер"
                    type="text"
                    mb="5"
                />
              </div>
            </div>
            <template v-if="!search">
              <div class="row">
                <div class="col-6">
                  <div class="form-floating mb-5">
                    <money3
                        v-model.number="vehicle.cost"
                        v-bind="config"
                        class="form-control form-control-solid"
                        placeholder="Действительная стоимость, тенге"
                        required
                        type="text"
                        name="vehicle.cost"
                        id='vehicle.cost'
                    />
                    <label for='vehicle.cost' class="required">Действительная стоимость</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-floating mb-5">
                    <money3
                        v-model.number="vehicle.amount"
                        :disabled="!vehicle.cost"
                        v-bind="config"
                        class="form-control form-control-solid"
                        placeholder="Страховая сумма, тенге"
                        required
                        type="text"
                        name="vehicle.amount"
                        id='vehicle.amount'
                    />
                    <label for='vehicle.amount' class="required">Страховая сумма</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input-mask-field
                      v-model="vehicle.year"
                      id="vehicle.year"
                      name="vehicle.year"
                      :required="true"
                      :mask="['####']"
                      placeholder="Год выпуска"
                      type="text"
                      mb="5"
                  />
                  <span class="text-danger" v-if="checkYear.message" v-html="checkYear.message"></span>
                </div>
                <div class="col-6">
                  <input-field
                      v-model="vehicle.color"
                      :required="true"
                      id="vehicle.color"
                      name="vehicle.color"
                      placeholder="Цвет"
                      type="text"
                      mb="5"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input-field
                      v-model="vehicle.mark"
                      id="vehicle.mark"
                      name="vehicle.mark"
                      :required="true"
                      placeholder="Марка"
                      type="text"
                      mb="5"
                  />
                </div>
                <div class="col-6">
                  <input-field
                      v-model="vehicle.model"
                      id="vehicle.model"
                      name="vehicle.model"
                      :required="true"
                      placeholder="Модель"
                      type="text"
                      mb="5"
                  />
                </div>
              </div>
              <div class="text-gray-700 fw-bold mb-3 ms-2">Регистрация</div>
              <div class="row">
                <div class="col-6">
                  <select-field
                      v-model="vehicle.type_id"
                      id="vehicle.type_id"
                      name="vehicle.type_id"
                      :disabled="true"
                      :options="vehicleType"
                      :required="true"
                      placeholder="Тип ТС"
                      mb="5"
                  />
                </div>
                <div class="col-6">
                  <input-field
                      v-model="vehicle.registration.certificate"
                      id="vehicle.registration_certificate"
                      name="vehicle.registration_certificate"
                      @input="vehicle.number=$event.target.value.toUpperCase()"
                      :required="true"
                      placeholder="Номер тех. паспорта"
                      type="text"
                      mb="5"
                  />
                </div>
                <div class="col-6">
                  <select-field-from-model
                      v-if="regions"
                      v-model="vehicle.registration.region_id"
                      :options="regions"
                      :required="true"
                      id="vehicle.registration"
                      name="vehicle.registration"
                      placeholder="Регион"
                      mb="5"
                  />
                </div>
                <div class="col-6">
                  <input-field
                      v-model="vehicle.registration.date"
                      :required="true"
                      id="vehicle.registration.date"
                      name="vehicle.registration.date"
                      placeholder="Дата выдачи"
                      type="date"
                      mb="5"
                  />
                </div>
              </div>
              <div class="text-gray-700 fw-bold mb-3 ms-2">Мотор</div>
              <div class="row">
                <div class="col-6">
                  <input-field
                      v-model="vehicle.engine.number"
                      @input="vehicle.engine.number=$event.target.value.toUpperCase()"
                      id="vehicle.engine.number"
                      name="vehicle.engine.number"
                      placeholder="Номер"
                      type="text"
                      mb="5"
                  />
                </div>
                <div class="col-6">
                  <input-field
                      v-model="vehicle.engine.power"
                      id="vehicle.engine.power"
                      name="vehicle.engine"
                      placeholder="Мощность"
                      type="number"
                      mb="5"
                  />
                </div>
                <div class="col-6">
                  <input-mask-field
                      v-model="vehicle.engine.volume"
                      id="vehicle.engine.volume"
                      name="vehicle.engine.volume"
                      :mask="['#####']"
                      placeholder="Объем"
                      type="text"
                      mb="5"
                  />
                </div>
              </div>
            </template>
            <input
                :disabled="!hasAdd"
                type="submit"
                class="btn btn-sm btn-primary btn-block"
                value="Сохранить"
            />
          </form>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Field
import SelectFieldFromModel from '@/components/Fields/SelectFieldFromModel'
import InputMaskField       from '@/components/Fields/InputMaskField'
import SelectField          from '@/components/Fields/SelectField'
import InputField           from '@/components/Fields/InputField'
// Other
import { Money3Component } from 'v-money3'
import LoaderFull          from '@/components/Main/LoaderFull'
import axios               from 'axios'

export default {
  name: 'SpecialistVehicleOneCModal',
  components: { SelectFieldFromModel, InputMaskField, SelectField, InputField, LoaderFull, money3: Money3Component },
  props: {
    changeItem: null,
    available: {
      type: Number,
      default: 0
    },
    productType:{
      type: Number,
      default: 6
    },
    carAddedList:{
      type: Array,
      default: () => []
    },
    module: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      checkYear:  false,
      regions:    null,
      loader:     false,
      search:     false,
      hasAdd:     false,
      error:      null,
      limit:      65000000,
      vehicle: {
        vehicle_id: 0,
        type_id:    6,
        premium:    0,
        amount:     0,
        model:      null,
        color:      null,
        cost:       0,
        year:       null,
        mark:       null,
        vin:        null,
        registration: {
          certificate: null,
          region_id:   null,
          big_city:    null,
          number:      null,
          date:        null,
          kato:        null,
        },
        engine: {
          number: null,
          volume: null,
          power:  null,
        },
        calc: {
          calculationDate:  null,
          premium:          0,
          message:          null,
          result:           true
        }
      },
      config: {
        precision:  2,
        thousands:  ' ',
        decimal:    '.',
        masked:     false,
        prefix:     '',
        suffix:     ' ₸'
      }
    }
  },
  mounted() {
    this.getRegions()
  },
  computed: {
    vehicleType() {
      return {
        6: 'Грузовые',
        10:'Прицепы/полуприцепы',
        15:'Спецтехника',
      }
    }
  },
  methods: {
    getRegions() {
      axios.get('/api/dictionaries/regions')
          .then(res => {
            this.regions = res.data
          })
    },
    getVehicle(number, vin, isVin) {
      if (!number && !vin) return
      if (number && number.length > 3) {
        const hasCar = this.carAddedList.indexOf(this.vehicle.vin) >= 0
        if (!hasCar) {
          this.search   = true
          const headers = {number:number, type: this.vehicle.type_id, vin: vin}
          axios.post('/api/vehicle/get-specialist-vehicle', headers)
              .then(res => {
                if (res.data.result) {
                  const hasCar = this.carAddedList.indexOf(res.data.data.vin) >= 0
                  if (!hasCar) {
                    this.vehicle = res.data.data
                    this.vehicle['calc'] = {
                      result:           true,
                      premium:          0,
                      message:          null,
                      calculationDate:  null
                    }
                    this.vehicle['premium'] = 0
                  } else {
                    this.error = 'ТС по '+number+' уже есть в списке.'
                  }
                } else {
                  this.$notifyError(res.data)
                  const number = isVin ? structuredClone(this.vehicle.vin) : structuredClone(this.vehicle.registration.number)
                  this.vehicle = this.module.Vehicle.vehicleDefaultValue(this.productType)
                  if (isVin) {
                    this.vehicle.vin                  = number
                    this.vehicle.registration.number  = null
                  } else {
                    this.vehicle.registration.number  = number
                    this.vehicle.vin                  = null
                  }
                }
              })
              .catch(err => {
                console.log(err.message)
              })
              .finally(() => this.search = false)
        } else {
          this.error = 'ТС по '+this.vehicle.vin+' уже есть в списке.'
        }
      }
    },
    clearForm() {
      this.loader = false
      this.modalHidden()
    },
    addVehicle() {
      if (this.hasAdd) {
        this.loader = true
        const data = {
          isEdit: this.changeItem.isEdit,
          key:    this.changeItem.key,
          data:   structuredClone(this.vehicle)
        }
        this.$emit('addVehicle', data)
        this.clearForm()
      }
    },
    modalHidden() {
      const myModalEl = document.getElementById('specialistVehicleOneCModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    }
  },
  watch: {
    changeItem: {
      deep: true,
      handler(val) {
        if (val) {
          this.vehicle          = val.isEdit ? val.data : this.module.Vehicle.vehicleDefaultValue(this.productType)
          this.vehicle.type_id  = this.productType
        }
      }
    },
    vehicle: {
      deep: true,
      handler(val) {
        this.limit  = this.limit > this.available  ? this.available : this.limit
        let temp    = this.module.Validator.vehicleValidate(val, this.limit)
        if (temp.result) {
          this.hasAdd = true
          this.error  = null
        } else {
          this.hasAdd = false
          this.error  = temp.message
        }

      }
    },
  }
}
</script>

<style scoped>

</style>